"use strict";

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  max-height: ", ";\n  width: ", ";\n  max-width: ", ";\n  padding: ", ";\n  margin: ", ";\n  display: ", ";\n  flex: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  text-align: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Box = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.height != null ? props.height : '';
}, function (props) {
  return props.maxHeight != null ? props.maxHeight : '';
}, function (props) {
  return props.width != null ? props.width : '';
}, function (props) {
  return props.maxWidth != null ? props.maxWidth : '';
}, function (props) {
  return props.padding != null ? props.padding : '';
}, function (props) {
  return props.margin != null ? props.margin : '';
}, function (props) {
  return props.display != null ? props.display : '';
}, function (props) {
  return props.flex != null ? props.flex : '';
}, function (props) {
  return props.flexDirection != null ? props.flexDirection : '';
}, function (props) {
  return props.flexGrow != null ? props.flexGrow : '';
}, function (props) {
  return props.flexShrink != null ? props.flexShrink : '';
}, function (props) {
  return props.justifyContent != null ? props.justifyContent : '';
}, function (props) {
  return props.alignItems != null ? props.alignItems : '';
}, function (props) {
  return props.textAlign != null ? props.textAlign : '';
});

var _default = Box;
exports["default"] = _default;